import { Outlet } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Header from "@layout/dashboard/Header";
import ProductSideNavBar from "@layout/dashboard/ProductSideNavBar";
import { Guard } from "@auth/Guard";
import { useParams } from "react-router-dom";
import { apiSend, getRoute } from "@services/axios";
import IBreadcrumb from "@components/IBreadcrumb";
import { useTranslation } from "react-i18next";
import { Config } from "@config/config";
import { ucfirst } from "@global/actions";
const DashboardProductLayout = () => {
  const config = new Config();
  const { t } = useTranslation();
  var profile = Guard();

  const themeOption = {
    dark: {
      color: "#2D2D30",
      nav: "bg-dark text-white",
      inpuSearch: "bg-dark text-white",
      text: "text-white",
    },
    light: {
      color: "#F7F9FB",
      nav: "border bg-white text-dark",
      inpuSearch: "bg-white text-dark",
      text: "text-dark",
    },
  };
  const theme = themeOption[profile.mode];

  const outletContextValue = {
    profile,
    theme,
  };
  const id = useParams().id;
  const service = useParams().service;
  const name = useParams().name;
  const country = useParams().country;
  var itemsCrumb = [
    {
      href: "/",
      title: config.icon("home", 18, 0.9),
    },
    {
      href: "/products",
      title: (
        <>
          {config.icon("settings", 18, 0.9)}
          <span className="m-1">{t("product")}</span>
        </>
      ),
    },
    {
      title: ucfirst(t(service)),
    },
    {
      title: name,
    },
  ];

  return (
    <div
      className="app-layout"
      style={{ background: theme.color }}
      id="app-layout"
    >
      <div class="pageWrap">
        <div class="page">
          <div class="aside">
            <div class="sidebar">
              <div class="sidebarBody">
                <ProductSideNavBar
                  profile={profile}
                  theme={theme}
                  service={service}
                  id={id}
                  country={country}
                  name={name}
                />
              </div>
            </div>
          </div>
          <div class="mainWrap">
            <div class="mainSection">
              {/* <div class="header px-3"></div> */}
            
                
                  <Header profile={profile} theme={theme}  />
           
              <div class="main">
                <div className="mainContent">
                
                  <Outlet context={outletContextValue} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardProductLayout;
